import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useAuth } from "../context/AuthContext";
import SideBarSupplier from "./SideBarSupplier";
import SideBarAgency from "./SideBarAgency";
import PropTypes from "prop-types";
import api from "../api/api";

const Sidebar = ({ vendors }) => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    // Fetch fetchNotifications based on user type
    const fetchNotifications = async () => {
      try {
     
        const response = await api.get(`notifications?type=${user.type}`);
       setNotifications(response.data);
      } catch (error) {
        console.error("Error fetching vendors:", error);
      }
    };

    if (user?.type) {
      fetchNotifications();
    }
  }, []);

  return (
    <>
      {user.type === "supplier" && <SideBarSupplier notify={notifications} />}
      {user.type === "agency" && (
        <SideBarAgency
          vendors={vendors}
          notify={notifications}
        />
      )}
    </>
  );
};

Sidebar.propTypes = {
  vendors: PropTypes.array.isRequired,
};
export default Sidebar;